import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/calss-attendances', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/calss-attendances', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTeachers = (options = {}) => {
  return httpClient
    .get('/api/calss-attendances/get-teacher-by-classes', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getAttendanceStatus = (Options = {}) => {
  return httpClient
    .get('/api/calss-attendances/attendance-status')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getPresentStatus = (Options = {}) => {
  return httpClient
    .get('/api/calss-attendances/present-status')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  getTeachers,
  getAttendanceStatus,
  getPresentStatus
}
